export class StoppingReasonTypeRuleListItem {
    stoppingReasonTypeRuleId: number;
    description: string;
    isEnabled: boolean;
}